import React, { useRef, useState, useEffect } from 'react';
import styles from './modafemininaclosetdaju.module.scss';
import Perfil from './src/perfil.png';

const Modafemininaclosetdaju: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.modafemininaclosetdaju}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4 mb-0">CLOSET DA JU</h1>
                    <p className="mb-4">Moda feminina</p>
                    <div className={styles.links}>
                        {[
                            {
                                title: 'Catálogo',
                                href: 'https://www.pinktech.com.br/menu/modafemininaclosetdaju',
                            },
                            {
                                title: 'Whatsapp',
                                href: 'https://wa.me/5516997872914?text=Olá, vim pelo link na bio e gostaria de mais informações...',
                            },
                            {
                                title: 'Localização',
                                href: 'https://maps.app.goo.gl/jdVhuXWLD78hdX6HA',
                            },
                            {
                                title: 'Grupo VIP',
                                href: 'https://chat.whatsapp.com/EWtI7tixE7x44dc6VrNeLT?mode=gi_t',
                            },
                            {
                                title: 'Instagram',
                                href: 'https://www.instagram.com/modafemininaclosetdaju?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
                            },
                        ].map(({ title, href }, index) => (
                            <a
                                key={index}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    background: '#F8F6F0',
                                    transition: 'background 0.5s ease',
                                    color: '#626B58',
                                    textAlign: 'center',
                                    padding: '5px 0px',
                                    borderRadius: '20px',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#ddd8cd';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = '#F8F6F0';
                                }}
                            >
                                <span style={{ letterSpacing: '2px', fontSize: '14px', fontWeight: 700 }}>
                                    {title}
                                </span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modafemininaclosetdaju;
